import axios from 'axios';
import { TOKEN, USERNAME, IDUSUARIO } from '../constants';

const GENERICO_URL = process.env.REACT_APP_SID_GENERICO;

export default function(codGrupo) {
  const config = {
    params: {
      codGrupo,
      codGrupoRec:'',
      codTipoRec: '',
    },
    headers: {
      codUsuario: USERNAME,
      idUsuario: IDUSUARIO,
      token: TOKEN,
    },
  };
  //http://172.20.200.45:8080/sid-generico/logistica/maestro/listardatos?codGrupo=36
  return axios.get(`${GENERICO_URL}/logistica/maestro/listardatos`, config);
}



// WEBPACK FOOTER //
// ./src/utils/getMotivosEntregas.js